import { rest, RestHandler } from 'msw';
import { PATHS } from 'adapters/constants';
import {
  testPrinters,
  printDataResponse
} from 'mocks/mockData/printerListData';

export const printerListHandler: RestHandler[] = [
  rest.get(PATHS.GET_PRINTERS_LIST('*'), (_, res, ctx) =>
    res(ctx.status(200), ctx.json(testPrinters))
  )
];

export const postPrintDataHandler: RestHandler[] = [
  rest.post(PATHS.PRINT_DOC, (_, res, ctx) =>
    res(ctx.status(200), ctx.json(printDataResponse))
  )
];
